import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { SystemStyleObject } from '@mui/system';
import React from 'react';

interface Props {
  readonly title: string | React.ReactElement;
  readonly description?: string;
  readonly value: string;
  readonly checked?: boolean;

  onClick?(value: string): void;
}

export const CardSelectItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { title, value, checked, description, onClick } = props;

  const containerStyle = React.useMemo(
    (): readonly SystemStyleObject[] | SystemStyleObject => [
      styles.card,
      checked ? styles.selected : {},
    ],
    [checked],
  );

  const handleClick = React.useCallback((): void => {
    onClick?.(value);
  }, [onClick, value]);

  return (
    <Box sx={containerStyle} onClick={handleClick}>
      {typeof title === 'string' ? (
        <Typography variant="body2" textAlign="center">
          {title}
        </Typography>
      ) : (
        title
      )}
      {description && (
        <Typography textAlign="center" color="custom.LightGray">
          {description}
        </Typography>
      )}
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  radio: {
    width: 0,
  },
  card: {
    width: '100%',
    padding: 3,
    borderRadius: 3,
    cursor: 'pointer',
    backgroundColor: 'custom.InputsBackground',
    borderWidth: 1.25,
    borderStyle: 'solid',
    borderColor: 'custom.InputsBackground',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    '&:hover': {
      borderColor: 'custom.BlackText',
    },
  },
  selected: {
    borderColor: 'custom.BlackText',
  },
};
